// removed by extract-text-webpack-plugin
module.exports = {"Error":"_3T1F_Ogtgp9A6NS8VF1-m","SuccessContainer":"_3BsbzgqJavL-PXlgk_G7Df"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ResetPassword/index.css
// module id = 822
// module chunks = 0